import { render, staticRenderFns } from "./CommonEmailShow.vue?vue&type=template&id=6b37e19e&scoped=true"
import script from "./CommonEmailShow.vue?vue&type=script&lang=js"
export * from "./CommonEmailShow.vue?vue&type=script&lang=js"
import style0 from "./CommonEmailShow.vue?vue&type=style&index=0&id=6b37e19e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37e19e",
  null
  
)

export default component.exports